import type { MapEmbed as MapEmbedType } from '../../lib/embeds/types';

export function MapEmbed({ query }: { query: MapEmbedType['query'] }) {
  const src = `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
  return (
    <div className="embed embed-map" style={{ position: 'relative', paddingTop: '56.25%' }}>
      <iframe
        title="Map"
        src={src}
        allowFullScreen
        loading="lazy"
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
      />
    </div>
  );
}
